import { render } from "./cesvegas.vue?vue&type=template&id=197ef6d8"
import script from "./cesvegas.vue?vue&type=script&lang=js"
export * from "./cesvegas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__